export default {
  lang: 'zh_cn',
  uploadImagesLocally: '本地上传图片',
  reset: '重置',
  'zh-cn': {
    reset: '重置'
  },
  'en-us': {
    reset: 'Reset'
  },
  'zh-tw': {
    reset: '重置'
  },
  'vi-vn': {
    reset: 'Thiết lập lại'
  },
  'id-id': {
    reset: 'Atur Ulang'
  }
}